import { createContext, FC, PropsWithChildren, useContext, useMemo } from "react";

export enum Vgt2Variant {
  Standard = "standard",
  IrFast = "ir-fast",
}

type Vgt2VariantContextValue = {
  variant: Vgt2Variant;
};

const Vgt2VariantContext = createContext<Vgt2VariantContextValue | null>(null);

type Vgt2VariantProviderProps = PropsWithChildren<{
  variant: Vgt2Variant;
}>;

export const Vgt2VariantProvider: FC<Vgt2VariantProviderProps> = ({ variant, children }) => {
  const value = useMemo<Vgt2VariantContextValue>(
    () => ({
      variant,
    }),
    [variant],
  );

  return <Vgt2VariantContext.Provider value={value}>{children}</Vgt2VariantContext.Provider>;
};

export const useVgt2Variant = () => {
  const context = useContext(Vgt2VariantContext);

  if (!context) {
    throw new Error("useVgt2Variant must be used within a Vgt2VariantProvider");
  }

  return context;
};
